import { render, staticRenderFns } from "./MainCampInfo.vue?vue&type=template&id=086dac09&scoped=true&"
import script from "./MainCampInfo.vue?vue&type=script&lang=js&"
export * from "./MainCampInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainCampInfo.vue?vue&type=style&index=0&id=086dac09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086dac09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
